import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import { useEffect, useState } from "react";
import CustomBreadcrumb from "../../components/CustomBreadcrumb";
import { Table } from "antd";
import BaseCard from "../../components/card/BaseCard";
import BaseTable from "../../components/BaseTable";
import type { TableProps } from "antd/lib";
import ButtonIcon from "../../components/ButtonIcon";
import ConfirmModal from "../../components/modal/ConfirmModal";
import { Link } from "react-router";
import { $api, type components } from "../../helper";
import { contactMock, tokenMock } from "../../helper/mock";
import ButtonLinkIcon from "../../components/ButtonLinkIcon";
import { useNotify } from "../../helper/notify";
import ButtonIconSvg from "../../components/ButtonIconSvg";
import Trash from "../../components/svg/Trash";
import ButtonLinkIconSvg from "../../components/ButtonLinkIconSvg";
import PenSquare from "../../components/svg/PenSquare";

export default function ContactInformation() {
  const [isOpen, setIsOpen] = useState(false);
  const notify = useNotify();
  const [id, setId] = useState("");
  const { mutate, isPending } = $api.useMutation(
    "delete",
    "/site-api/v1/contact-information/",
  );
  const { setDashboardName } = useStore(useDashboardName);
  const { data, isLoading, refetch } = $api.useQuery(
    "get",
    "/site-api/v1/contact-information/",
    {
      headers: {
        Authorization: tokenMock,
        lang: "fa",
      },
    },
  );
  useEffect(() => {
    setDashboardName("اطلاعات تماس");
  }, []);

  const columns: TableProps<
    components["schemas"]["SiteContactInformationItem"]
  >["columns"] = [
    {
      title: "#",
      dataIndex: "key",
      key: "key",
      render: (_, record, index) => <span>{index + 1}</span>,
    },
    {
      title: "عنوان اطلاعات تماس",
      dataIndex: "title",
      key: "title",
      render: (_, record) => (
        <span>
          {contactMock.find((e) => Number(e.value) === record.title)?.label}
        </span>
      ),
    },
    {
      title: "مقدار اطلاعات تماس",
      dataIndex: "value",
      key: "value",
    },
    {
      title: "عملیات",
      key: "action",
      render: (_, record) => (
        <div className="flex">
          {/* <ButtonLinkIcon
            icon="solar:pen-new-square-linear"
            className="text-primary-500!"
            to={{
              pathname: "/add-contact-information",
              search: "?u_id=" + record.u_id,
            }}
          /> */}
          <ButtonLinkIconSvg
            icon={<PenSquare />}
            className="text-primary-500!"
            to={{
              pathname: "/add-contact-information",
              search: "?u_id=" + record.u_id,
            }}
          />
          {/* <ButtonIcon
            icon="solar:trash-bin-trash-linear"
            className="text-error-500!"
            onClick={() => {
              setId(record.u_id);
              setIsOpen(true);
            }}
          /> */}
          <ButtonIconSvg
            icon={<Trash />}
            className="text-error-500!"
            onClick={() => {
              setId(record.u_id);
              setIsOpen(true);
            }}
          />
        </div>
      ),
    },
  ];

  return (
    <div className="flex flex-col gap-6">
      {/* modal */}
      <ConfirmModal
        pending={isPending}
        title="حذف اطلاعات تماس ؟"
        description="حذف این اطلاعات باعث عدم نمایش آن در بخش‌های مرتبط می‌شود."
        action={() => {
          mutate(
            {
              params: {
                query: {
                  contact_information_u_id: id,
                },
              },
              headers: {
                Authorization: tokenMock,
                lang: "fa",
              },
            },
            {
              onSuccess: (data) => {
                notify.success(data.message);
                setId("");
                setIsOpen(false);
                refetch();
              },
            },
          );
        }}
        open={isOpen}
        onClose={() => {
          setId("");
          setIsOpen(false);
        }}
      />
      <div className="w-full flex justify-between sm:flex-row sm:gap-0 gap-4 flex-col sm:items-center items-start">
        <CustomBreadcrumb first="مدیریت اطلاعات" second="اطلاعات تماس" />
        <Link to={"/add-contact-information"} className="button-style">
          افزودن اطلاعات تماس
        </Link>
      </div>

      <BaseCard props={{ className: "flex-1 flex-col flex gap-6" }}>
        <BaseTable props={{ className: "w-full grid! grid-cols-1!" }}>
          <Table<components["schemas"]["SiteContactInformationItem"]>
            loading={isLoading}
            className="col-span-1!"
            scroll={{ x: "max-content" }}
            columns={columns}
            dataSource={data?.data}
          />
        </BaseTable>
      </BaseCard>
    </div>
  );
}
